/**
 * @file 反馈合作资讯页请求方法
 * @author FengGuang(fengguang01@baidu.com)
 */

import request from 'superagent';
import baseRequest2 from '../baseApi2';


// 提交反馈表单
export interface IConsultationAndCooperationApiSubmitParam {
    companyName: string;
    // 主营业务
    mainBusiness: string;
    // 业务场景
    scene: string;
    // 是否使用深度学习框架
    isUsingDLFramework: string;
    // 使用的框架是
    framework: string[];
    // 遇到的问题
    problems: string;
    // 用户名
    name: string;
    // 职位
    position: string;
    phoneNumber: string;
    // 验证码
    verifyCode: string;
    // 验证码校验字符串，原封不动的返回给服务端
    randomStr: string;
    source: string;
}

export const fetchSubmit = (params: IConsultationAndCooperationApiSubmitParam): Promise<request.Response> =>
    baseRequest2(
        request.post('/platform/usercase/send')
            .query({type: 7})
            .send(params)
    );
